import { useCallback } from "react";
import { useHistory } from "react-router-dom";

type DatasetNavigationParams = {
  datasetId: number;
  datasetFolderId?: number;
};

const useDatasetViewerNavigation = ({
  datasetId,
  datasetFolderId,
}: DatasetNavigationParams) => {
  const history = useHistory();

  const navigateToDataset = useCallback(() => {
    if (datasetFolderId) {
      history.push(
        `/datasets/dataset-folders/${datasetFolderId}/dataset/${datasetId}/viewer`,
      );
    } else {
      history.push(`/datasets/${datasetId}/viewer`);
    }
  }, [history, datasetId, datasetFolderId]);

  return navigateToDataset;
};

export default useDatasetViewerNavigation;
